import * as React from "react";
import { observer } from "mobx-react";
import { useContext } from "react";
import { ContactViewStoreContext } from "../../context/store";
import { AnnotatedFormItem } from "./AnnotatedFormItem";
import { Input } from "antd";

export const SubNameFormItem = observer(() => {
  const store = useContext(ContactViewStoreContext);

  return (
    <AnnotatedFormItem
      label="パートナー様氏名"
      annotation="姓名の間にスペースを空けてください"
    >
      <Input
        value={store.subName}
        onChange={e => {
          store.subName = e.target.value;
        }}
      />
    </AnnotatedFormItem>
  );
});
